import { getToken } from "src/redux/selectors";

export function addExperience(values, activateDisplayId) {
  if (activateDisplayId) {
    values.activateDisplayId = true;
  }
  return dispatch =>
    new Promise((resolve, reject) => {
      return fetch(
        process.env.REACT_APP_GLOBAL_SERVER + "sproutmanagement/api/experience/addexperience",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
          body: JSON.stringify(values),
        }
      ).then(async res => {
        if (!res.ok) {
          return reject({ message: "Failed to add experience" });
        }
        return resolve(await res.text());
      });
    }).catch(err => {
      throw err.message;
    });
}

export function deleteExperience(id) {
  return dispatch =>
    new Promise((resolve, reject) => {
      return fetch(
        process.env.REACT_APP_GLOBAL_SERVER + "sproutmanagement/api/experience/deleteexperience",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
          body: JSON.stringify({ id: id }),
        }
      )
        .then(res => {
          if (!res.ok) {
            return reject({ message: "Failed to delete experience" });
          }
          res.text();
        })
        .catch(async error => {
          return reject(error);
        })
        .then(async response => {
          try {
            return resolve({ message: response });
          } catch (e) {
            return reject({ message: response });
          }
        });
    }).catch(err => {
      throw err.message;
    });
}

export function findAllExperience(access, year, months = []) {
  const baseUrl = process.env.REACT_APP_GLOBAL_SERVER + "sproutmanagement/api/experience/findallexperience";

  const query = new URLSearchParams();
  if (access) query.append("access", access);
  if (year) query.append("year", year);
  const normalizedMonths = Array.isArray(months) ? months : [months];
  if (normalizedMonths.length > 0) {
    query.append("months", normalizedMonths.join(","));
  }


  const url = `${baseUrl}?${query.toString()}`;

  return dispatch =>
    new Promise((resolve, reject) => {
      fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          Authorization: "Bearer " + getToken(),
          "Content-Type": "application/json; charset=utf-8",
        },
      })
        .then(async res => {
          if (!res.ok) {
            return reject({ message: await res.text() });
          }
          return resolve(
            dispatch({
              type: "EXPERIENCE_FIND_ALLEXPERIENCE",
              data: await res.json(),
            })
          );
        })
        .catch(err => {
          throw err.message;
        });
    });
}


export function setEditExperience(experience) {
  return dispatch =>
    dispatch({
      type: "EXPERIENCE_SET_EDITEXPERIENCE",
      data: experience,
    });
}

export function setExperienceDetailsId(id) {
  return dispatch =>
    dispatch({
      type: "EXPERIENCE_SET_EXPERIENCEDETAILSID",
      data: id,
    });
}
